module.exports = "<p>\n  create-account works!\n</p>\n"